import {
  PERFORM_REQUEST,
  PERFORM_REQUEST_FAILURE,
  PERFORM_REQUEST_SUCCESS,
  SET_PAGE,
    INIT_CATEGORIES,
    INIT_TAGS,
    INIT_CATEGORY,
    INIT_TAG,
  INIT_TITLE,
    SET_CATEGORY,
    SET_TAG,
    INIT_LANGUAGE,
  INIT_PAGE_SIZE,
  CLEAR_RESULTS,
  INIT_LOAD_MORE,
  INIT_LINK
} from './actions.mjs';

const initialState = {
  categories: [],
  tags: [],
  translations: {},
  loading: false,
  error: false,
  category: '',
  tag: '',
  loadMore: "",
  page: 0,
  language: null,
  size: 12,
  link: 0,
  results: {
      topicalsTotal: 0,
      topicalHits: [],
      hitCategories: [],
      hitTags: [],
      },
};

const articleListingReducer = (state = initialState, action) => {
    switch (action.type) {
      case INIT_LOAD_MORE:
        return Object.assign({}, state, {
          loadMore: action.loadMore
        });
      case INIT_PAGE_SIZE: 
        return Object.assign({}, state, {
          size: action.size
      });
      case INIT_LINK:
        return Object.assign({}, state, {
          link: action.link
        });
      case SET_CATEGORY:
          return Object.assign({}, state, {
            category: action.category,
              });
      case SET_TAG:
        return Object.assign({}, state, {
            tag: action.tag,
          });
    case INIT_TAG:
        return Object.assign({}, state, {
            tag: action.tag,
        });
    case INIT_CATEGORY:
        return Object.assign({}, state, {
            category: action.category,
        });

    case SET_PAGE:
      return Object.assign({}, state, {
        page: action.page,
      });
    case INIT_CATEGORIES:
      return Object.assign({}, state, {
        categories: action.categories,
          });
    case INIT_TAGS:
        return Object.assign({}, state, {
            tags: action.tags,
        });
    case INIT_LANGUAGE:
      return Object.assign({}, state, {
        language: action.language,
      });
    case INIT_TITLE:
      return Object.assign({}, state, {
        title: action.title,
      });
    case PERFORM_REQUEST:
      return Object.assign({}, state, {
        loading: true,
        error: false,
      });
    case CLEAR_RESULTS:
      return Object.assign({}, state, {
        results: {
          topicalsTotal: 0,
          topicalHits: [],
          hitCategories: state.results.hitCategories,
          hitTags: state.results.hitTags,     
        }
      });
    case PERFORM_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        results: { 
          topicalsTotal: action.data.topicalsTotal,
          topicalHits: state.results.topicalHits.concat(action.data.topicalHits),
          hitCategories: action.data.hitCategories,
          hitTags: action.data.hitTags,    
        },
        loading: false,
        error: false,
      });
    case PERFORM_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        error: true,
      });
    default:
      return state;
  }
};

export default articleListingReducer;
